import { useState } from "react";
import { media } from "@/lib/api";
import { MediaManager } from "./MediaManager";
import { ImagePlus, X } from "lucide-react";

export const GalleryField = ({ value, onChange, testid }) => {
  const [open, setOpen] = useState(false);
  const list = Array.isArray(value) ? value : [];
  const add = (u) => onChange([...list, u]);
  const remove = (i) => onChange(list.filter((_, idx) => idx !== i));

  return (
    <div>
      <div className="flex flex-wrap gap-2">
        {list.map((u, i) => (
          <div key={i} className="relative w-20 h-20 rounded-lg border border-white/10 overflow-hidden bg-black/40 group" data-testid={`${testid}-item-${i}`}>
            <img src={media(u)} alt="" className="w-full h-full object-cover" />
            <button type="button" onClick={() => remove(i)} data-testid={`${testid}-remove-${i}`}
              className="absolute top-1 right-1 p-1 rounded bg-black/70 opacity-0 group-hover:opacity-100 transition-opacity">
              <X size={11} className="text-rose-400" />
            </button>
          </div>
        ))}
        <button type="button" onClick={() => setOpen(true)} data-testid={testid}
          className="w-20 h-20 rounded-lg border border-dashed border-white/20 flex items-center justify-center text-slate-500 hover:border-cyan-400/40 hover:text-cyan-300 transition-colors">
          <ImagePlus size={20} />
        </button>
      </div>
      <MediaManager open={open} onOpenChange={setOpen} onSelect={add} />
    </div>
  );
};
